// import Vue from 'vue'
import moment from 'moment'

moment.locale('ko')
// Vue.prototype.$moment = moment

export default moment
